export enum PriceStatusEnum {
  PENDING = 'Pending',
  APPROVED = 'Approved',
  REJECTED = 'Rejected',
  REVOKED = 'Revoked',
  PRODUCTNOTFOUND = 'ProductNotFound',
}       